module.exports = __webpack_public_path__ + "img/2.7c13e149.png";